import React, { useReducer } from 'react'
import ScheduledPickupContext from './scheduledPickupContext'
import ScheduledPickupReducer from './scheduledPickupReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_SCHEDULED_PICKUP,
    GET_TODAY_COMPLETED,
    GET_TODAY_SERVING,
    GET_TODAY_WAITLIST,
    GET_TODAY_BOOKING,
    GET_ALL_SCHEDULED_PICKUP_USER_DATA,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './scheduledPickupTypes'

const ScheduledPickupState = (props) => {
    const initialState = {
        all_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        booking_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        serving_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        completed_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        waiting_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_scheduled_pickup_user: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
    }

    const [state, dispatch] = useReducer(ScheduledPickupReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllScheduledPickup = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllScheduledPickup',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])
            from = from ? from : 'schedulepickup'

            if (res.data.status === 'success') {
                dispatch({
                    type:
                        from == 'one'
                            ? 'GET_TODAY_BOOKING'
                            : from == 'two'
                            ? 'GET_TODAY_WAITLIST'
                            : from == 'three'
                            ? 'GET_TODAY_SERVING'
                            : from == 'four'
                            ? 'GET_TODAY_COMPLETED'
                            : 'GET_ALL_SCHEDULED_PICKUP',
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllScheduledPickupUserData = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllScheduledPickupUserData',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])
            from = from ? from : 'schedulepickupUser'
            console.log('777777777777', res.data.data.responseData)
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_SCHEDULED_PICKUP_USER_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeProductStatus = async (formData, from) => {
        try {
            //const from = 'productchange'
            from = from ? from : 'productchange'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const schedulePickupAction = async (formData, variable) => {
        try {
            const from = variable ? variable : 'scheduledPickupAction'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'scheduledPickupAction',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ScheduledPickupContext.Provider
            value={{
                all_scheduled_pickup: state.all_scheduled_pickup,
                waiting_scheduled_pickup: state.waiting_scheduled_pickup,
                serving_scheduled_pickup: state.serving_scheduled_pickup,
                completed_scheduled_pickup: state.completed_scheduled_pickup,
                booking_scheduled_pickup: state.booking_scheduled_pickup,
                all_scheduled_pickup_user: state.all_scheduled_pickup_user,
                responseStatus: state.responseStatus,
                clearResponse,
                getAllScheduledPickup,
                getAllScheduledPickupUserData,
                schedulePickupAction,
                changeProductStatus,
            }}
        >
            {props.children}
        </ScheduledPickupContext.Provider>
    )
}

export default ScheduledPickupState
